<template>
  <div>
    <h1 class="page-header">{{ $t('examschedule.examSchedule') }}</h1>
    <div class="row">
      <div
        v-show="isStaff"
        class="col-md-3 col-sm-12"
        :class="{ 'col-lg-3': isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div
        class="col-lg-9 col-md-9 col-sm-12"
        :class="{ 'col-lg-12': !isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px;"
                  class="kh-font"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table
            :columns="columns"
            :records="resources"
            :loading="loading"
            :rowGroup="{
              field: 'acps_name_foreign'
            }"
          >
            <template v-slot="{ record }">
              <td>{{ record.exam_name }}</td>
              <td>{{ record.start_date }}</td>
              <td>{{ record.end_date }}</td>
              <td>
                {{ $store.getters.limitStringShow(record.exam_criteria, 55) }}
              </td>
              <td class="text-center">
                <a
                  v-show="isStaff"
                  href="#"
                  title="edit"
                  class="text-primary mr-2"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  v-show="isStaff"
                  href="#"
                  title="delete"
                  class="text-danger"
                  @click.prevent="destroy(record.exam_sch_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'exam-schedule',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      student_id: null,
      route_leave: false,
      columns: [
        { name: this.$t('examschedule.name'), style: 'width: 20%;' },
        { name: this.$t('examschedule.startdate'), style: 'width: 12%;' },
        { name: this.$t('examschedule.enddate'), style: 'width: 12%;' },
        { name: this.$t('examschedule.criteria') },
        {
          name: this.$t('examschedule.actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    if (this.isParent) {
      this.student_id = this.$store.state.selectedStudent.student_id
    }
    if (this.isStudent) {
      this.student_id = this.$store.state.home.student.profile.student_id
    }
    if (this.isStaff || this.isTeacher) {
      this.fetchData()
    }
  },
  computed: {
    ...mapState('examSchedule', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.examSchedule.search
      },
      set(newVal) {
        this.$store.commit('examSchedule/SET_SEARCH', newVal)
        this.$store.commit('examSchedule/RESET_CURRENT_PAGE')
      }
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isParent() {
      return this.$store.getters.isParentLogin
    },
    isStudent() {
      return this.$store.getters.isStudentLogin
    },
    isTeacher() {
      return this.$store.getters.isTeacherLogin
    },
    selectedStudent() {
      return this.$store.state.selectedStudent.student_id
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('examSchedule/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/exam-schedules/${data.exam_sch_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('examSchedule/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    student_id: debounce(function(value) {
      this.fetchData({ student_id: value })
    }, 500),
    selectedStudent: debounce(function() {
      if (this.isParent) {
        this.student_id = null
        this.student_id = this.$store.state.selectedStudent.student_id
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'exam-schedule-create') {
      this.$store.commit('examSchedule/RESET_STATE')
      this.$store.commit('examSchedule/SET_SUB_PROGRAMS', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
